<template>
  <div :class="{
    'layout-default':true,
    ['page-layout-'+$route.name]:true,
    'erp-buy-layout-wrap':$isErpBuySite.value
  }">
    <slot name="header" >
      <PageRender
        key="header"
        v-if="headerActiveDetailData"
        :activeDetailData="headerActiveDetailData"
        :edit="false"
        :isPage="false"
        :currentElementIndex="[0]"
        :currentElementIndexStr="'0'"
      />
    </slot>
    <slot />
    <slot name="footer" >
      <PageRender
       
        key="footer"
        v-if="!$isErpBuySite.value&&footerActiveDetailData"
        :activeDetailData="footerActiveDetailData"
        :edit="false"
        :isPage="false"
        :currentElementIndex="[0]"
        :currentElementIndexStr="'0'"
      />
    </slot>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch, provide } from "vue";
import PageRender from "~/components/render/PageRender.vue";
import { useMainStore } from "../composables/store";
import {
  setPageHeaderStyleConfig
} from "~/composables/pageEditorUse";

import config from "~/config/index.js"
import {  useNuxtApp} from "#app";
 
const { $isErpBuySite } = useNuxtApp()
const { locale } = useI18n();
const store = useMainStore();

function makeActiveData(layoutConfig) {
  let res = null;
  if (store.$state.layoutData[layoutConfig]) {
    res = {
      currentPageConfig: store.$state.layoutData[layoutConfig][0],
      pages: store.$state.layoutData[layoutConfig],
      allArcListMap: {}
    };
  }
  return res;
}
const headerActiveDetailData = makeActiveData(config.layoutCommonConfig.header.url);
const footerActiveDetailData = makeActiveData(config.layoutCommonConfig.footer.url);
function getConfigJsonHook() {
    const localeCode = locale?.value || "zh-CN";
    const localeAliasMap = {
      "zh-CN": "hans",
      "zh-TW": "hant",
      "vi_VN": "vi",
      "ja_JP": "ja",
      en: "en",
    };
    const localeAlias = localeAliasMap[localeCode] || localeCode;
    let langJson={

    }
    let bindData = {
      common: {
        isH5: false,
        isMobile: false,
        appHidden: false,
        locale: localeCode,
        nowLocale: localeAlias,
      },
      locale: localeCode,
      nowLocale: localeAlias,
      siteInfo: store.getSiteInfo() || {},
      userInfo: store.$state.userInfo || {},
      mallUserInfo: store.$state.mallUserInfo || {},
    }
    if(headerActiveDetailData&&headerActiveDetailData.currentPageConfig){
       Object.assign(langJson,headerActiveDetailData.currentPageConfig?.langJson || {})
       Object.assign(bindData, headerActiveDetailData.currentPageConfig?.bindData || {})
    }
    if(footerActiveDetailData&&footerActiveDetailData.currentPageConfig){
       Object.assign(langJson,footerActiveDetailData.currentPageConfig?.langJson || {})
       Object.assign(bindData, footerActiveDetailData.currentPageConfig?.bindData || {})
    }
    return {
      langJson,
      bindData,
    };
}
if(headerActiveDetailData) setPageHeaderStyleConfig(headerActiveDetailData);
if(footerActiveDetailData) setPageHeaderStyleConfig(footerActiveDetailData);
provide("getCommonConfigJson", getConfigJsonHook);
</script>
  
